import { render, staticRenderFns } from "./outsource-label-return.vue?vue&type=template&id=0d356e66&scoped=true&"
import script from "./outsource-label-return.vue?vue&type=script&lang=js&"
export * from "./outsource-label-return.vue?vue&type=script&lang=js&"
import style0 from "./outsource-label-return.vue?vue&type=style&index=0&id=0d356e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d356e66",
  null
  
)

export default component.exports